const designationAndPaymentDiscountTransformer = data => {
  let maxDesignationDiscountPercentage = -1
  let maxDesignationAmountArray = []

  // finding max designation discount
  data?.DesignationDiscounts?.forEach(item => {
    if (item?.discount > maxDesignationDiscountPercentage && item?.discountType === "percentage") {
      maxDesignationDiscountPercentage = item?.discount || 0
    }
    if (item?.discountType === "amount") {
      maxDesignationAmountArray.push(item)
    }
  })

  return { ...data, maxDesignationDiscountPercentage, maxDesignationAmountArray }
}

export default designationAndPaymentDiscountTransformer
